// extracted by mini-css-extract-plugin
export default {"toolbar":"PolygonToolbar_toolbar__igH5t","divider":"PolygonToolbar_divider__gI4kK"};